import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ageText, locationText, occupationText } from '../data/participantDetails';

const Holder = styled.div`
  width: 100%;
  max-width: calc(${props => props.theme.maxWidth} * 0.8);
  background-color: ${props => props.theme.colours.ttcYellow};
  margin-top: -1rem;
  padding: 0.5rem .75rem .75rem;
  flex-grow: 1;
  z-index: 1;
  p { margin: 0; ${props => props.theme.typeStyles( -1 )}; }
`;

const Bold = styled.strong`
`;

class AvatarInfo extends Component {

  render() {
    const { details } = this.props;
    if ( details.workshop ) {
      return (
        <Holder>
          <p>Created by someone in the <Bold>{locationText(details.participantlocation)} {details.posting_date.slice(0, 10)}</Bold> workshop, aged <Bold>{ageText(details.participantage)}</Bold> and working in <Bold>{occupationText(details.participantoccupation)}</Bold>.</p>
        </Holder>
      )
    } else {
      return (
        <Holder>
          <p>Created by someone from <Bold>{locationText(details.participantlocation)}</Bold>, aged <Bold>{ageText(details.participantage)}</Bold> and working in <Bold>{occupationText(details.participantoccupation)}</Bold>.</p>
        </Holder>
      )
    }
  }
}

AvatarInfo.propTypes = {
  details: PropTypes.object,
};

export default AvatarInfo;
